export function messageBox (message, type = 'info', options = {}) {
  window.sysadminComponentsEventBus.emit('open', { message, type, options })
}
